// import * as types from './mutation-types.js'

export default {
  SET_ACTIVE(state, data) {
    state.active = data
  },

  SET_EMPTY(state) {
    state.historyTimeLine = {
      results: [],
    }
  },

  SET_CALL(state, data) {
    state.call = data
  },

  SET_UTILS_COMMIT(state, data) {
    state.utilsComments2 = {
      count: data.count,
      next: data.next,
      results: [
        ...state.utilsComments2.results,
        ...data.results,
      ],
    }
  },
  SET_UTILS_COMMIT_EMPTY(state) {
    state.utilsComments2 = {
      count: 0,
      results: [],
    }
  },
}
